'use client';

import { useEffect, useRef, memo, ComponentProps } from 'react';
import SearchBar from 'src/components/primitives/SearchBar/SearchBar';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

const MarketsSearchBar = ({
	id,
	searchValue,
	setSearchValue,
	placeholder,
	autoFocus = true,
	searchBarProps,
}: {
	id: string;
	searchValue: string;
	setSearchValue: (value: string) => void;
	placeholder: string;
	textFieldClassName?: string;
	bgClassName?: string;
	autoFocus?: boolean;
	searchBarProps?: Partial<ComponentProps<typeof SearchBar>>;
}) => {
	const isMobile = useIsMobileScreenSize();
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (inputRef.current && !isMobile && autoFocus) {
			(inputRef.current as HTMLElement).focus();
		}
	}, [autoFocus, isMobile]);

	return (
		<SearchBar
			id={id}
			size="sm"
			ref={inputRef}
			query={searchValue}
			setQuery={setSearchValue}
			placeholder={placeholder}
			{...searchBarProps}
		/>
	);
};

export default memo(MarketsSearchBar);
